'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.groups',
dependencies:['ui.router'],
configs:[
require('./groupsConfig')],

components:[
require('./groupsController'),
require('./modals/createGroupModalController'),
require('./modals/editGroupModalController'),
require('./modals/deleteGroupModalController'),
require('./modals/addPersonsToGroupModalController'),
require('./modals/setThresholdModalController')]});
//# sourceMappingURL=index.js.map
